var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeA(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236,
    height: 237,
    viewBox: "0 0 236 237",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.469 203.786V140.597L118.234 109L64 140.597V203.786L118.234 235.383L172.469 203.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.469 96.7861V33.5972L55.2343 2L1 33.5972V96.7861L55.2343 128.383L109.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.469 96.7861V33.5972L180.234 2L126 33.5972V96.7861L180.234 128.383L234.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeA);
export default __webpack_public_path__ + "static/media/shape-a.b6c187ec.svg";
export { ForwardRef as ReactComponent };